import { createContext, useContext } from 'react';

export interface SessionUser {
  id: number;
  username: string;
  realName: string;
  email: string;
  accessLevel: number;
}

export type SessionState =
  | { status: 'loading' }
  | { status: 'anonymous' }
  | { status: 'authenticated'; user: SessionUser; accessToken: string };

export interface SessionApi {
  state: SessionState;
  /** Password login; resolves with the user, rejects with ApiError (401/423/429…). */
  login: (username: string, password: string, remember: boolean) => Promise<SessionUser>;
  /** Re-check the refresh cookie (e.g. after activation). */
  refresh: () => Promise<void>;
  logout: () => Promise<void>;
}

export const SessionContext = createContext<SessionApi | null>(null);

export function useSession(): SessionApi {
  const s = useContext(SessionContext);
  if (!s) throw new Error('useSession must be used inside <SessionProvider>');
  return s;
}

/** Legacy access levels (config_defaults_inc.php): the thresholds the manifest's `access` uses. */
export const ACCESS_LEVEL = { user: 10, manager: 70, admin: 90 } as const;
